<template>
  <div class="col backgroundForm">
    <h5 align="center">Formulario de transferencia de privilegios y acceso al sistema</h5>
        <vue-bootstrap-typeahead                            
                v-model="persons"
                :data="persons_list"
                size="sm"
                :serializer="item => (item.grade +' '+item.complete+' CI. '+item.identification)"
                @hit="mSelectPerson"
                :placeholder="searchPerson"                                        
            />
        <br><br>
        <div v-if="person_select.id > 0">
            <h6><b>Personal Seleccionada a transferir Role</b></h6>
            <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                    <div class="input-group-text">{{person_select.grade}} {{person_select.complete}} <b> &nbsp; C.I. &nbsp;</b>{{ person_select.identification }}</div>
                </div>
                <input type="text" class="form-control" placeholder="Usuario" autocomplete="off" v-model="person_select.nick">
                <button class="btn btn-outline-success" :disabled="boton_charge" @click="mTransfiereUsuario"><font-awesome-icon icon="arrows-alt-h" :bounce="boton_charge" /> Transferir</button>
            </div>
            <br>
            <div class="form-row">
                <p class="text-danger">NOTA IMPORTANTE</p>
                <p class="text-body"> Cuando realice la operacion de transferencia de acceso al sistema su usuario quedara inhabilitado, ademas indicar que la <b>contraseña del nuevo usuario sera su cedula de identidad,</b> por lo que se recomienda que verifique sus datos de la Persona antes de dar de alta en el sistema, <b>asimismo el responsable deberá solicitar a la DGCP la habilitación del Capitán de Puerto</b></p>
            </div>
        </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import modalLoading from '../modal/modalLoading';
const qs = require('qs');

export default {
    data(){
        return{
            persons:null,
            persons_list:[],
            searchPerson:'Busqueda de Personas',
            person_select:{
                id:0,
                complete:'',
                grade:'',
                identification:'',
                nick:'',
                first_name:'',
                last_name:''
            },
            boton_charge:false
        }
    },
    methods:{
        logout(){
            this.$auth.destroyToken();
            this.$router.push('/auth/login');
            this.$store.dispatch('sessionDestroy',true);
        },
        mSelectPerson(data){            
            this.person_select.id=data.id;
            this.person_select.complete=data.complete;
            this.person_select.charge=data.complete;
            this.person_select.identification=data.identification;
            this.person_select.grade=data.grade;
            this.person_select.first_name=data.first_name;
            this.person_select.last_name=data.last_name;
            this.person_select.name=data.name;
            this.person_select.nick=this.mGeneraNick();
        },
        mClearSelectPerson(){
            this.person_select.id=0;
            this.person_select.complete='';
            this.person_select.charge='';
            this.person_select.identification='';
            this.person_select.grade='';
            this.person_select.first_name='';
            this.person_select.last_name='';
            this.person_select.name='';
            this.person_select.nick='';
        },
        mValidaTransferencia(){
          if(this.person_select.nick.trim()===''){
            toastr.warning(`Debe señalar un usuario para su registro`)
            return false;
          }
        //   aqui podemos señalar si va al servidor a consultar si el usuario esta vigente opcional
          return true;
        },
        async mTransfiereUsuario(){
            if(this.mValidaTransferencia()){
                // aqui enviamos al servidor a registrar el usuario
                let message = {
                    title: 'Transferencia de Usuario',
                    body: `¿Desea Registrar la transferencia de roles de su Usuario <b>${this.cDtsUser.nick}</b> al Usuario <b>${this.person_select.nick}</b> perteneciente a la persona <b>${this.person_select.complete}</b>, cerrando su sistema?`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.boton_charge = true;
                            let n_user_ordop=await axios.post(`registerNewUser?api_token=${Vue.auth.getToken()}`, qs.stringify(this.person_select));
                            setTimeout(()=>{                                
                                if(n_user_ordop.data.status){
                                    toastr.success(n_user_ordop.data.respuesta);
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    this.boton_charge = false;
                                    // limpiamos los registros previamente obtenemos el id
                                    this.mClearSelectPerson();
                                    this.logout()
                                }else{
                                    toastr.warning(n_user_ordop.data.respuesta);
                                    this.boton_charge = false;
                                }
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error O-01')
                                this.btn_p_ordop = false;
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
                this.btn_p_ordop = false;
                
            }
        },
        mGetRandomInt(max) {
            return Math.floor(Math.random() * max);
        },
        mGeneraNick(){
            let aux=`${this.person_select.name.charAt(0)}${this.person_select.first_name}_${this.mGetRandomInt(2025)}`;
            aux= aux.replace(/ /g, "").toLowerCase();
            return aux;
        }
    },
    watch:{
        persons(newPerson){
            axios.get(`searchPerson/${newPerson}?api_token=${Vue.auth.getToken()}`)
            .then((res)=>{
                console.log(res);
                this.persons_list=res.data;
            }).catch(err=>{
                console.log(err);
            })
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/user/TransferUser.vue